import React from 'react';
import _isFunction from 'lodash/isFunction';
import InputNumber from 'rc-input-number';

import { Children, IPropsWithClassName } from 'interfaces';
import { ReactComponent as CheckIcon } from '@icons/check.svg';
import { ReactComponent as CloseIcon } from '@icons/close.svg';
import styles from './styles';

// import { InlineSvg } from 'images/InlineSvg';

// const CheckIcon = ({ className }: { className?: string }) => (
//   <InlineSvg svgContent={_CheckIcon} className={className} />
// );

// const CloseIcon = ({ className }: { className?: string }) => (
//   <InlineSvg svgContent={_CloseIcon} className={className} />
// );

export interface InputProps extends IPropsWithClassName {
  id: string;
  label?: string;
  placeholder?: Children;
  type?: string;
  value?: string;
  onChange(value: string | number): void;
  error?: boolean | string | null;
  step?: string;
  checked?: boolean;
  min?: number;
  max?: number;
}

const Input = ({
  id,
  label,
  placeholder,
  type = 'number',
  className,
  value,
  onChange,
  error,
  step = '.01',
  checked,
  min,
  max,
}: InputProps) => {
  const componentStyles = styles.component(className, type);

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.target;
    if (_isFunction(onChange)) {
      onChange(inputValue);
    }
  };

  const onInputNumberChange = (newValue: string | null) => {
    if (_isFunction(onChange)) {
      if (_isFunction(onChange) && newValue !== null) {
        onChange(newValue);
      }
    }
  };

  const isInputNumber = type === 'number';

  const stringError =
    error && typeof error === 'string' ? (
      <small className={styles.error}>{error}</small>
    ) : null;
  return (
    <div className={componentStyles}>
      {label && (
        <label
          htmlFor={id}
          className={styles.label(Boolean(type === 'checkbox'))}
        >
          {label}
        </label>
      )}
      {isInputNumber && (
        <InputNumber
          id={id}
          className={styles.input(Boolean(error), false)}
          type={type}
          inputMode="decimal"
          value={value}
          onChange={onInputNumberChange}
        />
      )}
      {!isInputNumber && (
        <input
          id={id}
          className={styles.input(Boolean(error), Boolean(type === 'checkbox'))}
          type={type}
          value={value}
          onChange={onInputChange}
          step={step}
          checked={checked}
          min={min}
          max={max}
        />
      )}
      {type === 'checkbox' && (
        <label htmlFor={id} className={styles.checkbox(checked)}>
          {checked ? (
            <span className={styles.icon(checked)}>
              <CheckIcon />
            </span>
          ) : (
            <span className={styles.icon(checked)}>
              <CloseIcon />
            </span>
          )}
        </label>
      )}
      {placeholder && (
        <label htmlFor={id} className={styles.placeholder(Boolean(label))}>
          {placeholder}
        </label>
      )}
      {stringError}
    </div>
  );
};

export default Input;
